module.exports = __webpack_public_path__ + "fonts/selima-webfont.3a7fc931.woff";